export default "__VITE_PUBLIC_ASSET__daba995d__"